/** Shared chart labels used outside statistics pages. */
export const chartsCommonSv = {
    legend: {
        currentPeriod: 'Aktuell period',
        oneYearAgo: '1 år sedan',
        futureAndOngoingRightsIssues: 'Kommande/pågående företrädesemissioner',
    },
    table: {
        quarter: 'Kvartal',
        countAverage: 'Antal (medelvärde)',
        count: 'Antal',
    },
    units: {
        st: 'st',
    },
}
